import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

//通过 Status 和时间条件给 badge 的 BackgroundColor 赋值
export function checkPopUpNote({ parameter, pageComponent } = {}) {
  let popupNoteIconShow = false;
  let popupNoteShow = false;
  let popUpNotes = [];
  parameter.map((item, i) => {
    if (item.Popup) {
      popupNoteIconShow = true;
      popupNoteShow = true;
      popUpNotes.push(item);
    }
  })
  if (pageComponent.state.popupNoteShow === null) {
    pageComponent.setState({ popupNoteShow });
  }
  pageComponent.setState({ popupNoteIconShow, popUpNotes });
}

export function loadNoteTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter > 0) {
    httpClient
      .get('Admin/NoteTemplate/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ Content: data.data.Content });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//打开 JobNote 的回收站
export function openRecycleBin({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ jobNoteRecycleBinShow: true });
  let searchParameter = { ...sectionComponent.state.searchParameter };
  let jobId = sectionComponent.props.searchParameter.jobId;
  httpClient
    .get('/Business/JobNote/GetRecycleBinList?jobId=' + jobId)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.jobNoteRecycleBin.current?.setState({ data: data.data, selectedRowKeys: [] });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
